/**
 * Set top space of sections to properly scroll to anchor
 * 
 * @param array sections Array with queryselectors
 */
export const setTopSpace = ( sections ) => {

    if ( ! sections || ! sections[0] ) {
        return;
    }

    const header = document.querySelector( '#masthead' );
    const headerHeight = header.offsetHeight;

    sections.forEach( (section) => {
        section.style.paddingTop = `${ headerHeight + 80 }px`;
        section.style.marginTop = `-${ headerHeight + 80 }px`;
    })

}